import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { usePostHog } from 'posthog-js/react'

import { useAuth } from '@/features/auth/hooks/use-auth.ts'

export const Identifier = () => {
  const auth = useAuth()
  const posthog = usePostHog()

  useEffect(() => {
    if (auth?.user) {
      posthog.identify(auth.user.id, {
        username: auth.user.user_metadata?.username,
      })

      Sentry.setUser({
        id: auth.user.id,
        username: auth.user.user_metadata?.username,
      })
    }
  }, [auth.user, posthog])

  return null
}
